export const highlightTime = 60;
